export default __webpack_public_path__ + "static/imdb-7c0b9e2254a222ef1fa9f79efc33c12a.png";